﻿function $d(e) {
  return document.getElementById(e);
}
var addeventatc = (function () {
  var v,
    m,
    l,
    t,
    e = !1,
    s = 1,
    r = !1,
    p = !0,
    u = !1,
    g = !1,
    f = !1,
    E = 1,
    h = "",
    w = !0,
    x = !0,
    b = !0,
    k = !0,
    y = !0,
    _ = !0,
    T = !0,
    N = "Apple",
    z = "Google <em>(online)</em>",
    I = "Office 365 <em>(online)</em>",
    C = "Outlook",
    $ = "Outlook.com <em>(online)</em>",
    A = "Yahoo <em>(online)</em>",
    L = "Facebook Event",
    S = null,
    H = null,
    a = null,
    R = null,
    M = null,
    O = null;
  return {
    initialize: function () {
      if (!e) {
        e = !0;
        try {
          addeventasync();
        } catch (e) {}
        (addeventatc.trycss(), addeventatc.generate());
      }
    },
    generate: function () {
      for (
        var c = document.getElementsByTagName("*"), i = 0;
        i < c.length;
        i += 1
      )
        addeventatc.hasclass(c[i], "addeventatc") &&
          (function () {
            var a = "addeventatc" + s;
            ((c[i].id = a),
              addeventatc.hasclass(c[i], "keeptitle") || (c[i].title = ""),
              (c[i].style.visibility = "visible"),
              c[i].setAttribute("aria-haspopup", "true"),
              c[i].setAttribute("aria-expanded", "false"),
              c[i].setAttribute("tabindex", "0"),
              c[i].setAttribute("translate", "no"),
              c[i].setAttribute("data-loaded", "true"),
              r
                ? ((c[i].onclick = function () {
                    return !1;
                  }),
                  (c[i].onmouseover = function () {
                    (clearTimeout(l),
                      addeventatc.toogle(this, { type: "mouseover", id: a }));
                  }),
                  (c[i].onmouseout = function () {
                    l = setTimeout(function () {
                      addeventatc.mouseout(this, { type: "mouseout", id: a });
                    }, 100);
                  }))
                : ((c[i].onclick = function () {
                    return (
                      addeventatc.toogle(this, { type: "click", id: a }),
                      !1
                    );
                  }),
                  (c[i].onmouseover = function () {}),
                  (c[i].onmouseout = function () {})),
              (c[i].onkeydown = function (e) {
                var t = e.which || e.keyCode;
                (("13" != t &&
                  "32" != t &&
                  "27" != t &&
                  "38" != t &&
                  "40" != t) ||
                  e.preventDefault(),
                  ("13" != t && "32" != t) ||
                    (addeventatc.keyboardclick(this, { type: "click", id: a }),
                    addeventatc.toogle(this, {
                      type: "click",
                      id: a,
                      keynav: !0,
                    })),
                  "27" == t && addeventatc.hideandreset(),
                  "9" == t && addeventatc.hideandreset(),
                  "38" == t &&
                    addeventatc.keyboard(this, {
                      type: "keyboard",
                      id: a,
                      key: "up",
                    }),
                  "40" == t &&
                    addeventatc.keyboard(this, {
                      type: "keyboard",
                      id: a,
                      key: "down",
                    }),
                  0);
              }),
              (c[i].onblur = function () {}));
            var e,
              t = c[i];
            (("none" != c[i].getAttribute("data-styling") &&
              "inline-buttons" != c[i].getAttribute("data-render")) ||
              (p = !1),
              p &&
                (((e = document.createElement("span")).className =
                  "addeventatc_icon"),
                t.appendChild(e)),
              s++,
              (u = !0));
            for (
              var n = c[i].getElementsByTagName("*"), o = 0;
              o < n.length;
              o += 1
            )
              addeventatc.hasclass(n[o], "atc_node") ||
                ("" != n[o].className
                  ? (n[o].className += " atc_node notranslate")
                  : (n[o].className += "atc_node"));
            if ("inline-buttons" == c[i].getAttribute("data-render")) {
              ((c[i].onclick = function () {}),
                addeventatc.toogle(c[i], { type: "render", id: a }),
                c[i].setAttribute("aria-expanded", "true"),
                c[i].removeAttribute("tabindex"),
                (c[i].onkeydown = function () {}),
                (c[i].blur = function () {}));
              var d = document.getElementById(a + "-drop");
              if (d) {
                d.setAttribute("aria-hidden", "false");
                for (
                  n = d.getElementsByTagName("SPAN"), o = 0;
                  o < n.length;
                  o += 1
                ) {
                  n[o];
                  ((n[o].tabIndex = "0"),
                    (n[o].onkeydown = function (e) {
                      var t = e.which || e.keyCode;
                      ("13" != t && "32" != t) || e.target.click();
                    }));
                }
              }
            }
          })();
      (p
        ? addeventatc.applycss()
        : (addeventatc.removeelement($d("ate_css")),
          addeventatc.removeelement($d("ate_tmp_css")),
          addeventatc.helpercss()),
        u && !g && ((g = !0), addeventatc.track({ typ: "exposure", cal: "" })));
    },
    toogle: function (e, t) {
      var a,
        n = !1,
        o = "",
        d = !1,
        c = e.id,
        i = $d(c);
      if (i) {
        a = i.getAttribute("data-direct");
        var l = i.getAttribute("data-intel"),
          s = i.getAttribute("data-intel-apple");
        "ios" == addeventatc.agent() &&
          "click" == t.type &&
          "true" !== s &&
          "false" !== l &&
          ((a = "appleical"), i.setAttribute("data-intel-apple", "true"));
        try {
          "" != $d(c).querySelector(".recurring").innerHTML && (d = !0);
        } catch (e) {}
        if (
          "outlook" == a ||
          "google" == a ||
          "yahoo" == a ||
          "hotmail" == a ||
          "outlookcom" == a ||
          "appleical" == a ||
          "apple" == a ||
          "facebook" == a
        )
          "click" == t.type &&
            (addeventatc.click({ button: c, service: a, id: t.id }),
            null != S && addeventatc.trigger("button_click", { id: c }));
        else if (
          ("mouseover" == t.type && m != i && (f = !1),
          "click" == t.type ||
            "render" == t.type ||
            ("mouseover" == t.type && !f))
        ) {
          ("mouseover" == t.type &&
            ((f = !0),
            null != H && addeventatc.trigger("button_mouseover", { id: c })),
            (n = addeventatc.getburl({ id: c, facebook: !0 })),
            "" == h &&
              (h =
                "appleical,google,office365,outlook,outlookcom,yahoo,facebook"));
          for (
            var r, p = (h = (h += ",").replace(/ /gi, "")).split(","), u = 0;
            u < p.length;
            u += 1
          )
            (((w && "ical" == p[u]) || (w && "appleical" == p[u])) &&
              (o +=
                '<span class="ateappleical" id="' +
                c +
                '-appleical" role="menuitem" tabindex="-1">' +
                N +
                "</span>"),
              x &&
                "google" == p[u] &&
                (o +=
                  '<span class="ategoogle" id="' +
                  c +
                  '-google" role="menuitem" tabindex="-1">' +
                  z +
                  "</span>"),
              b &&
                "office365" == p[u] &&
                (o +=
                  '<span class="ateoffice365" id="' +
                  c +
                  '-office365" role="menuitem" tabindex="-1">' +
                  I +
                  "</span>"),
              k &&
                "outlook" == p[u] &&
                (o +=
                  '<span class="ateoutlook" id="' +
                  c +
                  '-outlook" role="menuitem" tabindex="-1">' +
                  C +
                  "</span>"),
              ((y && "hotmail" == p[u]) || (y && "outlookcom" == p[u])) &&
                (o +=
                  '<span class="ateoutlookcom" id="' +
                  c +
                  '-outlookcom" role="menuitem" tabindex="-1">' +
                  $ +
                  "</span>"),
              _ &&
                "yahoo" == p[u] &&
                !d &&
                (o +=
                  '<span class="ateyahoo" id="' +
                  c +
                  '-yahoo" role="menuitem" tabindex="-1">' +
                  A +
                  "</span>"),
              n &&
                "facebook" == p[u] &&
                T &&
                "facebook" == p[u] &&
                (o +=
                  '<span class="atefacebook" id="' +
                  c +
                  '-facebook" role="menuitem" tabindex="-1">' +
                  L +
                  "</span>"));
          (addeventatc.getlicense(v) ||
            (o +=
              '<em class="copyx"><em class="brx"></em><em class="frs"><a href="https://www.addevent.com" title="" tabindex="-1" id="' +
              c +
              '-home">AddEvent.com</a></em></em>'),
            $d(c + "-drop") ||
              (((r = document.createElement("span")).id = c + "-drop"),
              (r.className = "addeventatc_dropdown"),
              r.setAttribute("aria-hidden", "true"),
              r.setAttribute("aria-labelledby", c),
              (r.innerHTML = o),
              i.appendChild(r)),
            $d(c + "-appleical") &&
              ($d(c + "-appleical").onclick = function () {
                addeventatc.click({
                  button: c,
                  service: "appleical",
                  id: t.id,
                });
              }),
            $d(c + "-google") &&
              ($d(c + "-google").onclick = function () {
                addeventatc.click({ button: c, service: "google", id: t.id });
              }),
            $d(c + "-office365") &&
              ($d(c + "-office365").onclick = function () {
                addeventatc.click({
                  button: c,
                  service: "office365",
                  id: t.id,
                });
              }),
            $d(c + "-outlook") &&
              ($d(c + "-outlook").onclick = function () {
                addeventatc.click({ button: c, service: "outlook", id: t.id });
              }),
            $d(c + "-outlookcom") &&
              ($d(c + "-outlookcom").onclick = function () {
                addeventatc.click({
                  button: c,
                  service: "outlookcom",
                  id: t.id,
                });
              }),
            $d(c + "-yahoo") &&
              ($d(c + "-yahoo").onclick = function () {
                addeventatc.click({ button: c, service: "yahoo", id: t.id });
              }),
            $d(c + "-facebook") &&
              ($d(c + "-facebook").onclick = function () {
                addeventatc.click({ button: c, service: "facebook", id: t.id });
              }),
            $d(c + "-home") &&
              ($d(c + "-home").onclick = function () {
                addeventatc.click({ button: c, service: "home", id: t.id });
              }),
            addeventatc.show(c, t));
        }
        return ((m = i), !1);
      }
    },
    click: function (e) {
      var t,
        a,
        n,
        o,
        d = !0,
        c = window.location.href,
        i = $d(e.button);
      if (i) {
        ("home" == e.service
          ? (a = "https://www.addevent.com")
          : ((t = addeventatc.getburl({ id: e.button, facebook: !1 })),
            (a =
              "https://www.addevent.com/create/?service=" +
              e.service +
              t +
              "&reference=" +
              c),
            ("outlook" != e.service && "appleical" != e.service) ||
              ((d = !1),
              addeventatc.usewebcal() &&
                (a =
                  "webcal://www.addevent.com/create/?uwc=on&service=" +
                  e.service +
                  t +
                  "&reference=" +
                  c)),
            null !== (n = i.getAttribute("data-id")) &&
              (a = addeventatc.usewebcal()
                ? "webcal://www.addevent.com/event/" +
                  n +
                  "+" +
                  e.service +
                  "/?uwc=on"
                : "https://www.addevent.com/event/" + n + "+" + e.service)),
          $d("atecllink") ||
            (((o = document.createElement("a")).id = "atecllink"),
            (o.rel = "external"),
            o.setAttribute("data-role", "none"),
            (o.innerHTML = "{addeventatc-ghost-link}"),
            (o.style.display = "none"),
            document.body.appendChild(o)));
        var l = $d("atecllink");
        if (
          ((l.target = d ? "_blank" : "_self"),
          (l.href = a),
          addeventatc.eclick("atecllink"),
          addeventatc.track({ typ: "click", cal: e.service }),
          null != O)
        ) {
          addeventatc.trigger("button_dropdown_click", {
            id: e.button,
            service: e.service,
          });
          try {
            (event || window.event).stopPropagation();
          } catch (e) {}
        }
      }
    },
    mouseout: function (e, t) {
      ((f = !1),
        addeventatc.hideandreset(),
        null != a && addeventatc.trigger("button_mouseout", { id: t.id }));
    },
    show: function (e, t) {
      var a,
        n,
        o,
        d,
        c,
        i,
        l,
        s,
        r,
        p,
        u,
        v,
        m,
        g,
        f,
        h,
        w,
        x,
        b,
        k,
        y,
        _,
        T = $d(e),
        N = $d(e + "-drop");
      T &&
        N &&
        ("block" == addeventatc.getstyle(N, "display")
          ? addeventatc.hideandreset()
          : (addeventatc.hideandreset(!0),
            (N.style.display = "block"),
            (T.style.outline = "0"),
            (E = addeventatc.topzindex()),
            (T.style.zIndex = E + 1),
            (T.className = T.className.replace(/\s+/g, " ")),
            T.setAttribute("aria-expanded", "true"),
            N.setAttribute("aria-hidden", "false"),
            t.keynav &&
              addeventatc.keyboard(this, {
                type: "keyboard",
                id: e,
                key: "down",
              }),
            (o = "auto"),
            (d = null != (a = T.getAttribute("data-dropdown-x")) ? a : "auto"),
            null != (n = T.getAttribute("data-dropdown-y")) && (o = n),
            (N.style.left = "0px"),
            (N.style.top = "0px"),
            (N.style.display = "block"),
            (c = parseInt(T.offsetHeight)),
            (i = parseInt(T.offsetWidth)),
            (l = parseInt(N.offsetHeight)),
            (s = parseInt(N.offsetWidth)),
            (r = addeventatc.viewport()),
            (p = parseInt(r.w)),
            (u = parseInt(r.h)),
            (v = parseInt(r.x)),
            (m = parseInt(r.y)),
            (g = addeventatc.elementposition(N)),
            (f = parseInt(g.x)),
            parseInt(g.y),
            (h = addeventatc.elementposition(T)).x,
            (w = f + s),
            (x = p + v),
            (k = b = 0),
            (y = ""),
            (_ = h.y - (l / 2 - c)),
            "down" == o && "left" == d
              ? ((k = b = "-2px"), (y = "topdown"))
              : "up" == o && "left" == d
                ? ((b = "0px"), (k = -(l - c - 2) + "px"))
                : "down" == o && "right" == d
                  ? ((b = -(s - i - 2) + "px"), (k = "-2px"), (y = "topdown"))
                  : "up" == o && "right" == d
                    ? ((b = -(s - i - 2) + "px"), (k = -(l - c - 2) + "px"))
                    : "auto" == o && "left" == d
                      ? ((b = "0px"),
                        _ < m
                          ? ((k = "-2px"), (y = "topdown"))
                          : (k =
                              m + u < _ + l
                                ? -(l - c - 2) + "px"
                                : -(l / 2 - c) + "px"))
                      : "auto" == o && "right" == d
                        ? ((b = -(s - i - 2) + "px"),
                          _ < m
                            ? ((k = "-2px"), (y = "topdown"))
                            : (k =
                                m + u < _ + l
                                  ? -(l - c - 2) + "px"
                                  : -(l / 2 - c) + "px"))
                        : "down" == o && "auto" == d
                          ? ((b = x < w ? -(s - i - 2) + "px" : "-2px"),
                            (k = "-2px"),
                            (y = "topdown"))
                          : "up" == o && "auto" == d
                            ? ((b = x < w ? -(s - i - 2) + "px" : "-2px"),
                              (k = -(l - c - 2) + "px"))
                            : (_ < m
                                ? ((k = "-2px"), (y = "topdown"))
                                : (k =
                                    m + u < _ + l
                                      ? -(l - c - 2) + "px"
                                      : -(l / 2 - c) + "px"),
                              (b = x < w ? -(s - i - 2) + "px" : "-2px")),
            (N.style.left = b),
            (N.style.top = k),
            "" != y && (N.className = N.className + " " + y),
            setTimeout(function () {
              N.className = N.className + " addeventatc-selected";
            }, 1),
            "click" == t.type &&
              null != S &&
              addeventatc.trigger("button_click", { id: e }),
            null != R &&
              addeventatc.trigger("button_dropdown_show", { id: e })));
    },
    hide: function (e) {
      var t = !1;
      ((("string" == typeof e && "" !== e) ||
        (e instanceof String && "" !== e)) &&
        (-1 < e.indexOf("addeventatc") || -1 < e.indexOf("atc_node")) &&
        (t = !0),
        t || addeventatc.hideandreset());
    },
    hideandreset: function (e) {
      for (
        var t = "", a = document.getElementsByTagName("*"), n = 0;
        n < a.length;
        n += 1
      )
        if (addeventatc.hasclass(a[n], "addeventatc")) {
          ((a[n].className = a[n].className.replace(
            /addeventatc-selected/gi,
            "",
          )),
            (a[n].className = a[n].className.replace(/\s+$/, "")),
            (a[n].style.outline = ""));
          var o = $d(a[n].id + "-drop");
          if (o) {
            var d = addeventatc.getstyle(o, "display");
            ("block" == d && (t = a[n].id),
              (o.style.display = "none"),
              "block" !== (d = addeventatc.getstyle(o, "display")) &&
                (a[n].setAttribute("aria-expanded", "false"),
                o.setAttribute("aria-hidden", "true"),
                (o.className = o.className.replace(
                  /addeventatc-selected/gi,
                  "",
                )),
                (o.className = o.className.replace(/topdown/gi, "")),
                o.removeAttribute("style")));
            for (
              var c = o.getElementsByTagName("SPAN"), i = 0;
              i < c.length;
              i += 1
            ) {
              var l = new RegExp("(\\s|^)drop_markup(\\s|$)");
              ((c[i].className = c[i].className.replace(l, " ")),
                (c[i].className = c[i].className.replace(/\s+$/, "")),
                (c[i].tabIndex = "-1"));
            }
          }
        }
      e ||
        (null != M && addeventatc.trigger("button_dropdown_hide", { id: t }));
    },
    getburl: function (e) {
      var t = $d(e.id),
        a = "",
        n = !1;
      if (t) {
        for (var o = t.getElementsByTagName("*"), d = 0; d < o.length; d += 1)
          ((addeventatc.hasclass(o[d], "_start") ||
            addeventatc.hasclass(o[d], "start")) &&
            (a += "&dstart=" + encodeURIComponent(o[d].innerHTML)),
            (addeventatc.hasclass(o[d], "_end") ||
              addeventatc.hasclass(o[d], "end")) &&
              (a += "&dend=" + encodeURIComponent(o[d].innerHTML)),
            (addeventatc.hasclass(o[d], "_zonecode") ||
              addeventatc.hasclass(o[d], "zonecode")) &&
              (a += "&dzone=" + encodeURIComponent(o[d].innerHTML)),
            (addeventatc.hasclass(o[d], "_timezone") ||
              addeventatc.hasclass(o[d], "timezone")) &&
              (a += "&dtime=" + encodeURIComponent(o[d].innerHTML)),
            (addeventatc.hasclass(o[d], "_summary") ||
              addeventatc.hasclass(o[d], "summary") ||
              addeventatc.hasclass(o[d], "title")) &&
              (a += "&dsum=" + encodeURIComponent(o[d].innerHTML)),
            (addeventatc.hasclass(o[d], "_description") ||
              addeventatc.hasclass(o[d], "description")) &&
              (a += "&ddesc=" + encodeURIComponent(o[d].innerHTML)),
            (addeventatc.hasclass(o[d], "_location") ||
              addeventatc.hasclass(o[d], "location")) &&
              (a += "&dloca=" + encodeURIComponent(o[d].innerHTML)),
            (addeventatc.hasclass(o[d], "_organizer") ||
              addeventatc.hasclass(o[d], "organizer")) &&
              (a += "&dorga=" + encodeURIComponent(o[d].innerHTML)),
            (addeventatc.hasclass(o[d], "_organizer_email") ||
              addeventatc.hasclass(o[d], "organizer_email")) &&
              (a += "&dorgaem=" + encodeURIComponent(o[d].innerHTML)),
            (addeventatc.hasclass(o[d], "_attendees") ||
              addeventatc.hasclass(o[d], "attendees")) &&
              (a += "&datte=" + encodeURIComponent(o[d].innerHTML)),
            (addeventatc.hasclass(o[d], "_all_day_event") ||
              addeventatc.hasclass(o[d], "all_day_event")) &&
              (a += "&dallday=" + encodeURIComponent(o[d].innerHTML)),
            (addeventatc.hasclass(o[d], "_date_format") ||
              addeventatc.hasclass(o[d], "date_format")) &&
              (a += "&dateformat=" + encodeURIComponent(o[d].innerHTML)),
            (addeventatc.hasclass(o[d], "_alarm_reminder") ||
              addeventatc.hasclass(o[d], "alarm_reminder")) &&
              (a += "&alarm=" + encodeURIComponent(o[d].innerHTML)),
            (addeventatc.hasclass(o[d], "_recurring") ||
              addeventatc.hasclass(o[d], "recurring")) &&
              (a += "&drule=" + encodeURIComponent(o[d].innerHTML)),
            (addeventatc.hasclass(o[d], "_facebook_event") ||
              addeventatc.hasclass(o[d], "facebook_event")) &&
              ((a += "&fbevent=" + encodeURIComponent(o[d].innerHTML)),
              (n = !0)),
            (addeventatc.hasclass(o[d], "_client") ||
              addeventatc.hasclass(o[d], "client")) &&
              (a += "&client=" + encodeURIComponent(o[d].innerHTML)),
            (addeventatc.hasclass(o[d], "_calname") ||
              addeventatc.hasclass(o[d], "calname")) &&
              (a += "&calname=" + encodeURIComponent(o[d].innerHTML)),
            (addeventatc.hasclass(o[d], "_uid") ||
              addeventatc.hasclass(o[d], "uid")) &&
              (a += "&uid=" + encodeURIComponent(o[d].innerHTML)),
            (addeventatc.hasclass(o[d], "_sequence") ||
              addeventatc.hasclass(o[d], "sequence")) &&
              (a += "&seq=" + encodeURIComponent(o[d].innerHTML)),
            (addeventatc.hasclass(o[d], "_status") ||
              addeventatc.hasclass(o[d], "status")) &&
              (a += "&status=" + encodeURIComponent(o[d].innerHTML)),
            (addeventatc.hasclass(o[d], "_method") ||
              addeventatc.hasclass(o[d], "method")) &&
              (a += "&method=" + encodeURIComponent(o[d].innerHTML)),
            (addeventatc.hasclass(o[d], "_transp") ||
              addeventatc.hasclass(o[d], "transp")) &&
              (a += "&transp=" + encodeURIComponent(o[d].innerHTML)));
        ("true" == t.getAttribute("data-google-api") && (a += "&gapi=true"),
          "true" == t.getAttribute("data-outlook-api") && (a += "&oapi=true"));
      }
      return (e.facebook && (a = n), a);
    },
    trycss: function () {
      if (!$d("ate_tmp_css")) {
        try {
          var e = "",
            e = ".addeventatc {visibility:hidden;}";
          ((e += ".addeventatc .data {display:none!important;}"),
            (e +=
              ".addeventatc .start, .addeventatc .end, .addeventatc .timezone, .addeventatc .title, .addeventatc .description, .addeventatc .location, .addeventatc .organizer, .addeventatc .organizer_email, .addeventatc .facebook_event, .addeventatc .all_day_event, .addeventatc .date_format, .addeventatc .alarm_reminder, .addeventatc .recurring, .addeventatc .attendees, .addeventatc .client, .addeventatc .calname, .addeventatc .uid, .addeventatc .sequence, .addeventatc .status, .addeventatc .method, .addeventatc .transp {display:none!important;}"),
            p &&
              (e +=
                ".addeventatc {background-image:url(https://www.addevent.com/gfx/icon-calendar-t5.png), url(https://www.addevent.com/gfx/icon-calendar-t1.svg), url(https://www.addevent.com/gfx/icon-apple-t5.svg), url(https://www.addevent.com/gfx/icon-facebook-t5.svg), url(https://www.addevent.com/gfx/icon-google-t5.svg), url(https://www.addevent.com/gfx/icon-office365-t5.svg), url(https://www.addevent.com/gfx/icon-outlook-t5.svg),  url(https://www.addevent.com/gfx/icon-outlookcom-t5.svg), url(https://www.addevent.com/gfx/icon-yahoo-t5.svg);background-position:-9999px -9999px;background-repeat:no-repeat;}"));
          var t = document.createElement("style");
          ((t.type = "text/css"),
            (t.id = "ate_tmp_css"),
            t.styleSheet
              ? (t.styleSheet.cssText = e)
              : t.appendChild(document.createTextNode(e)),
            document.getElementsByTagName("head")[0].appendChild(t));
        } catch (e) {}
        addeventatc.track({ typ: "jsinit", cal: "" });
      }
    },
    applycss: function () {
      var e, t;
      ($d("ate_css") &&
        !$d("ate_css_plv") &&
        ($d("ate_css").id = $d("ate_css").id.replace(
          /ate_css/gi,
          "ate_css_plv",
        )),
        $d("ate_css") ||
          ((e = ""),
          (e +=
            '@import url("https://fonts.googleapis.com/css?family=Open+Sans:400,400i,600");'),
          (e +=
            '.addeventatc \t\t\t\t\t\t\t{display:inline-block;position:relative;z-index:99998;font-family:"Open Sans",Roboto,"Helvetica Neue",Helvetica,Optima,Segoe,"Segoe UI",Candara,Calibri,Arial,sans-serif;color:#000!important;font-weight:600;line-height:100%;background:#fff;font-size:15px;text-decoration:none;border:1px solid transparent;padding:13px 12px 12px 43px;-webkit-border-radius:3px;border-radius:3px;cursor:pointer;-webkit-font-smoothing:antialiased!important;outline-color:rgba(0,78,255,0.5);text-shadow:1px 1px 1px rgba(0,0,0,0.004);-webkit-user-select:none;-webkit-tap-highlight-color:rgba(0,0,0,0);box-shadow:0 0 0 0.5px rgba(50,50,93,.17), 0 2px 5px 0 rgba(50,50,93,.1), 0 1px 1.5px 0 rgba(0,0,0,.07), 0 1px 2px 0 rgba(0,0,0,.08), 0 0 0 0 transparent!important;background-image:url(https://www.addevent.com/gfx/icon-calendar-t5.png), url(https://www.addevent.com/gfx/icon-calendar-t1.svg), url(https://www.addevent.com/gfx/icon-apple-t5.svg), url(https://www.addevent.com/gfx/icon-facebook-t5.svg), url(https://www.addevent.com/gfx/icon-google-t5.svg), url(https://www.addevent.com/gfx/icon-office365-t5.svg), url(https://www.addevent.com/gfx/icon-outlook-t5.svg), url(https://www.addevent.com/gfx/icon-outlookcom-t5.svg), url(https://www.addevent.com/gfx/icon-yahoo-t5.svg);background-position:-9999px -9999px;background-repeat:no-repeat;}'),
          (e +=
            ".addeventatc:hover \t\t\t\t\t\t{background-color:#fafafa;color:#000;font-size:15px;text-decoration:none;}"),
          (e +=
            ".addeventatc:active \t\t\t\t\t{border-width:2px 1px 0px 1px;}"),
          (e += ".addeventatc-selected \t\t\t\t\t{background-color:#f9f9f9;}"),
          (e +=
            ".addeventatc .addeventatc_icon \t\t\t{width:18px;height:18px;position:absolute;z-index:1;left:12px;top:10px;background:url(https://www.addevent.com/gfx/icon-calendar-t1.svg) no-repeat;background-size:18px 18px;}"),
          (e +=
            ".addeventatc .start, .addeventatc .end, .addeventatc .timezone, .addeventatc .title, .addeventatc .description, .addeventatc .location, .addeventatc .organizer, .addeventatc .organizer_email, .addeventatc .facebook_event, .addeventatc .all_day_event, .addeventatc .date_format, .addeventatc .alarm_reminder, .addeventatc .recurring, .addeventatc .attendees, .addeventatc .calname, .addeventatc .uid, .addeventatc .sequence, .addeventatc .status, .addeventatc .method, .addeventatc .client, .addeventatc .transp {display:none!important;}"),
          (e += ".addeventatc br \t\t\t\t\t\t{display:none;}"),
          addeventatc.getlicense(v)
            ? (e +=
                '.addeventatc_dropdown \t\t\t\t{width:230px;position:absolute;padding:6px 0px 6px 0px;font-family:"Open Sans",Roboto,"Helvetica Neue",Helvetica,Optima,Segoe,"Segoe UI",Candara,Calibri,Arial,sans-serif;color:#000!important;font-weight:600;line-height:100%;background:#fff;font-size:15px;text-decoration:none;text-align:left;margin-left:-1px;display:none;-moz-border-radius:3px;-webkit-border-radius:3px;-webkit-box-shadow:rgba(0,0,0,0.4) 0px 10px 26px;-moz-box-shadow:rgba(0,0,0,0.4) 0px 10px 26px;box-shadow:rgba(0,0,0,0.4) 0px 10px 26px;transform:scale(.98,.98) translateY(5px);opacity:0.5;z-index:-1;transition:transform .15s ease;-webkit-user-select:none;-webkit-tap-highlight-color:rgba(0,0,0,0);}')
            : (e +=
                '.addeventatc_dropdown \t\t\t\t{width:230px;position:absolute;padding:6px 0px 0px 0px;font-family:"Open Sans",Roboto,"Helvetica Neue",Helvetica,Optima,Segoe,"Segoe UI",Candara,Calibri,Arial,sans-serif;color:#000!important;font-weight:600;line-height:100%;background:#fff;font-size:15px;text-decoration:none;text-align:left;margin-left:-1px;display:none;-moz-border-radius:3px;-webkit-border-radius:3px;-webkit-box-shadow:rgba(0,0,0,0.4) 0px 10px 26px;-moz-box-shadow:rgba(0,0,0,0.4) 0px 10px 26px;box-shadow:rgba(0,0,0,0.4) 0px 10px 26px;transform:scale(.98,.98) translateY(5px);opacity:0.5;z-index:-1;transition:transform .15s ease;-webkit-user-select:none;-webkit-tap-highlight-color:rgba(0,0,0,0);}'),
          (e +=
            ".addeventatc_dropdown.topdown \t\t\t{transform:scale(.98,.98) translateY(-5px)!important;}"),
          (e +=
            ".addeventatc_dropdown span \t\t\t\t{display:block;line-height:100%;background:#fff;text-decoration:none;cursor:pointer;font-size:15px;color:#333;font-weight:600;padding:14px 10px 14px 55px;margin:-2px 0px;}"),
          (e +=
            ".addeventatc_dropdown span:hover \t\t{background-color:#f4f4f4;color:#000;text-decoration:none;font-size:15px;}"),
          (e +=
            ".addeventatc_dropdown em \t\t\t\t{color:#999!important;font-size:12px!important;font-weight:400;}"),
          (e +=
            ".addeventatc_dropdown .frs a \t\t\t{background:#fff;color:#cacaca!important;cursor:pointer;font-size:9px!important;font-style:normal!important;font-weight:400!important;line-height:110%!important;padding-left:10px;position:absolute;right:10px;text-align:right;text-decoration:none;top:5px;z-index:101;}"),
          (e +=
            ".addeventatc_dropdown .frs a:hover \t\t{color:#999!important;}"),
          (e +=
            ".addeventatc_dropdown .ateappleical \t{background:url(https://www.addevent.com/gfx/icon-apple-t5.svg) 18px 40% no-repeat;background-size:22px 100%;}"),
          (e +=
            ".addeventatc_dropdown .ategoogle \t\t{background:url(https://www.addevent.com/gfx/icon-google-t5.svg) 18px 50% no-repeat;background-size:22px 100%;}"),
          (e +=
            ".addeventatc_dropdown .ateoffice365 \t{background:url(https://www.addevent.com/gfx/icon-office365-t5.svg) 19px 50% no-repeat;background-size:18px 100%;}"),
          (e +=
            ".addeventatc_dropdown .ateoutlook \t\t{background:url(https://www.addevent.com/gfx/icon-outlook-t5.svg) 18px 50% no-repeat;background-size:22px 100%;}"),
          (e +=
            ".addeventatc_dropdown .ateoutlookcom \t{background:url(https://www.addevent.com/gfx/icon-outlookcom-t5.svg) 18px 50% no-repeat;background-size:22px 100%;}"),
          (e +=
            ".addeventatc_dropdown .ateyahoo \t\t{background:url(https://www.addevent.com/gfx/icon-yahoo-t5.svg) 18px 50% no-repeat;background-size:22px 100%;}"),
          (e +=
            ".addeventatc_dropdown .atefacebook \t\t{background:url(https://www.addevent.com/gfx/icon-facebook-t5.svg) 18px 50% no-repeat;background-size:22px 100%;}"),
          (e +=
            ".addeventatc_dropdown .copyx \t\t\t{height:21px;display:block;position:relative;cursor:default;}"),
          (e +=
            ".addeventatc_dropdown .brx \t\t\t\t{height:1px;overflow:hidden;background:#e8e8e8;position:absolute;z-index:100;left:10px;right:10px;top:9px;}"),
          (e +=
            ".addeventatc_dropdown.addeventatc-selected {opacity:1;transform:scale(1,1) translateY(0px);z-index:99999999;}"),
          (e +=
            ".addeventatc_dropdown.topdown.addeventatc-selected {transform:scale(1,1) translateY(0px)!important;}"),
          (e +=
            ".addeventatc_dropdown .drop_markup {background-color:#f4f4f4;}"),
          ((t = document.createElement("style")).type = "text/css"),
          (t.id = "ate_css"),
          t.styleSheet
            ? (t.styleSheet.cssText = e)
            : t.appendChild(document.createTextNode(e)),
          document.getElementsByTagName("head")[0].appendChild(t),
          addeventatc.removeelement($d("ate_tmp_css"))));
    },
    helpercss: function () {
      var e, t;
      $d("ate_helper_css") ||
        ((e = ""),
        (e += ".addeventatc_dropdown .drop_markup {background-color:#f4f4f4;}"),
        (e +=
          ".addeventatc_dropdown .frs a {margin:0!important;padding:0!important;font-style:normal!important;font-weight:normal!important;line-height:110%!important;background-color:#fff!important;text-decoration:none;font-size:9px!important;color:#cacaca!important;display:inline-block;}"),
        (e += ".addeventatc_dropdown .frs a:hover {color:#999!important;}"),
        (e +=
          ".addeventatc .start, .addeventatc .end, .addeventatc .timezone, .addeventatc .title, .addeventatc .description, .addeventatc .location, .addeventatc .organizer, .addeventatc .organizer_email, .addeventatc .facebook_event, .addeventatc .all_day_event, .addeventatc .date_format, .addeventatc .alarm_reminder, .addeventatc .recurring, .addeventatc .attendees, .addeventatc .client, .addeventatc .calname, .addeventatc .uid, .addeventatc .sequence, .addeventatc .status, .addeventatc .method, .addeventatc .transp {display:none!important;}"),
        ((t = document.createElement("style")).type = "text/css"),
        (t.id = "ate_helper_css"),
        t.styleSheet
          ? (t.styleSheet.cssText = e)
          : t.appendChild(document.createTextNode(e)),
        document.getElementsByTagName("head")[0].appendChild(t));
    },
    removeelement: function (e) {
      try {
        return !!(hdx = e) && hdx.parentNode.removeChild(hdx);
      } catch (e) {}
    },
    topzindex: function () {
      for (
        var e, t = 1, a = document.getElementsByTagName("*"), n = 0;
        n < a.length;
        n += 1
      ) {
        (addeventatc.hasclass(a[n], "addeventatc") ||
          addeventatc.hasclass(a[n], "addeventstc")) &&
          ((e = addeventatc.getstyle(a[n], "z-index")),
          !isNaN(parseFloat(e)) &&
            isFinite(e) &&
            t < (e = parseInt(e)) &&
            (t = e));
      }
      return t;
    },
    viewport: function () {
      var e = 0,
        t = 0,
        a = 0,
        n = 0;
      return (
        "number" == typeof window.innerWidth
          ? ((e = window.innerWidth), (t = window.innerHeight))
          : document.documentElement &&
              (document.documentElement.clientWidth ||
                document.documentElement.clientHeight)
            ? ((e = document.documentElement.clientWidth),
              (t = document.documentElement.clientHeight))
            : document.body &&
              (document.body.clientWidth || document.body.clientHeight) &&
              ((e = document.body.clientWidth),
              (t = document.body.clientHeight)),
        (a = document.all
          ? ((n = document.documentElement.scrollLeft
              ? document.documentElement.scrollLeft
              : document.body.scrollLeft),
            document.documentElement.scrollTop
              ? document.documentElement.scrollTop
              : document.body.scrollTop)
          : ((n = window.pageXOffset), window.pageYOffset)),
        { w: e, h: t, x: n, y: a }
      );
    },
    elementposition: function (e) {
      var t = 0,
        a = 0;
      if (e.offsetParent)
        for (t = e.offsetLeft, a = e.offsetTop; (e = e.offsetParent); )
          ((t += e.offsetLeft), (a += e.offsetTop));
      return { x: t, y: a };
    },
    getstyle: function (e, t) {
      var a;
      return (
        e.currentStyle
          ? (a = e.currentStyle[t])
          : window.getComputedStyle &&
            (a = document.defaultView
              .getComputedStyle(e, null)
              .getPropertyValue(t)),
        a
      );
    },
    getlicense: function (e) {
      var t,
        a,
        n,
        o = location.origin,
        d = !1;
      return (
        void 0 === location.origin &&
          (o = location.protocol + "//" + location.host),
        e &&
          ((t = e.substring(0, 1)),
          (a = e.substring(9, 10)),
          (n = e.substring(17, 18)),
          "a" == t && "z" == a && "m" == n && (d = !0)),
        ((-1 == o.indexOf("addevent.com") && "aao8iuet5zp9iqw5sm9z" == e) ||
          (-1 == o.indexOf("addevent.to") && "aao8iuet5zp9iqw5sm9z" == e) ||
          (-1 == o.indexOf("addevent.com") && "aao8iuet5zp9iqw5sm9z" == e)) &&
          (d = !0),
        d
      );
    },
    refresh: function () {
      for (
        var e = document.getElementsByTagName("*"), t = [], a = 0;
        a < e.length;
        a += 1
      )
        if (addeventatc.hasclass(e[a], "addeventatc")) {
          ((e[a].className = e[a].className.replace(
            /addeventatc-selected/gi,
            "",
          )),
            (e[a].id = ""));
          for (
            var n = e[a].getElementsByTagName("*"), o = 0;
            o < n.length;
            o += 1
          )
            (addeventatc.hasclass(n[o], "addeventatc_icon") ||
              addeventatc.hasclass(n[o], "addeventatc_dropdown")) &&
              t.push(n[o]);
        }
      for (var d = 0; d < t.length; d += 1) addeventatc.removeelement(t[d]);
      (addeventatc.removeelement($d("ate_css")),
        (g = !(s = 1)),
        addeventatc.generate());
    },
    hasclass: function (e, t) {
      return new RegExp("(\\s|^)" + t + "(\\s|$)").test(e.className);
    },
    eclick: function (e) {
      var t,
        a = document.getElementById(e);
      a.click
        ? a.click()
        : document.createEvent &&
          ((t = document.createEvent("MouseEvents")).initEvent("click", !0, !0),
          a.dispatchEvent(t));
    },
    track: function (e) {
      (new Image(),
        new Date().getTime(),
        encodeURIComponent(window.location.origin));
    },
    getguid: function () {
      for (
        var e,
          t,
          a,
          n = "addevent_track_cookie=",
          o = "",
          d = document.cookie.split(";"),
          c = 0;
        c < d.length;
        c++
      ) {
        for (var i = d[c]; " " == i.charAt(0); ) i = i.substring(1, i.length);
        0 == i.indexOf(n) && (o = i.substring(n.length, i.length));
      }
      return (
        "" == o &&
          ((e = (
            addeventatc.s4() +
            addeventatc.s4() +
            "-" +
            addeventatc.s4() +
            "-4" +
            addeventatc.s4().substr(0, 3) +
            "-" +
            addeventatc.s4() +
            "-" +
            addeventatc.s4() +
            addeventatc.s4() +
            addeventatc.s4()
          ).toLowerCase()),
          (t = new Date()).setTime(t.getTime() + 31536e6),
          (a = "expires=" + t.toUTCString()),
          (document.cookie = "addevent_track_cookie=" + e + "; " + a),
          (o = e)),
        o
      );
    },
    s4: function () {
      return ((65536 * (1 + Math.random())) | 0).toString(16).substring(1);
    },
    documentclick: function (e) {
      ((e = (e = e || window.event).target || e.srcElement),
        ate_touch_capable
          ? (clearTimeout(t),
            (t = setTimeout(function () {
              addeventatc.hide(e.className);
            }, 200)))
          : addeventatc.hide(e.className));
    },
    trigger: function (e, t) {
      if ("button_click" == e)
        try {
          S(t);
        } catch (e) {}
      if ("button_mouseover" == e)
        try {
          H(t);
        } catch (e) {}
      if ("button_mouseout" == e)
        try {
          a(t);
        } catch (e) {}
      if ("button_dropdown_show" == e)
        try {
          R(t);
        } catch (e) {}
      if ("button_dropdown_hide" == e)
        try {
          M(t);
        } catch (e) {}
      if ("button_dropdown_click" == e)
        try {
          O(t);
        } catch (e) {}
    },
    register: function (e, t) {
      ("button-click" == e && (S = t),
        "button-mouseover" == e && (H = t),
        "button-mouseout" == e && (a = t),
        "button-dropdown-show" == e && (R = t),
        "button-dropdown-hide" == e && (M = t),
        "button-dropdown-click" == e && (O = t));
    },
    settings: function (e) {
      (null != e.license && (v = e.license),
        null != e.css &&
          (e.css
            ? (p = !0)
            : ((p = !1), addeventatc.removeelement($d("ate_css")))),
        null != e.mouse && (r = e.mouse),
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent,
        ) && (r = !1),
        null != e.outlook && null != e.outlook.show && (k = e.outlook.show),
        null != e.google && null != e.google.show && (x = e.google.show),
        null != e.office365 &&
          null != e.office365.show &&
          (b = e.office365.show),
        null != e.yahoo && null != e.yahoo.show && (_ = e.yahoo.show),
        null != e.hotmail && null != e.hotmail.show && (y = e.hotmail.show),
        null != e.outlookcom &&
          null != e.outlookcom.show &&
          (y = e.outlookcom.show),
        null != e.ical && null != e.ical.show && (w = e.ical.show),
        null != e.appleical &&
          null != e.appleical.show &&
          (w = e.appleical.show),
        null != e.facebook && null != e.facebook.show && (T = e.facebook.show),
        null != e.outlook && null != e.outlook.text && (C = e.outlook.text),
        null != e.google && null != e.google.text && (z = e.google.text),
        null != e.office365 &&
          null != e.office365.text &&
          (I = e.office365.text),
        null != e.yahoo && null != e.yahoo.text && (A = e.yahoo.text),
        null != e.hotmail && null != e.hotmail.text && ($ = e.hotmail.text),
        null != e.outlookcom &&
          null != e.outlookcom.text &&
          ($ = e.outlookcom.text),
        null != e.ical && null != e.ical.text && (N = e.ical.text),
        null != e.appleical &&
          null != e.appleical.text &&
          (N = e.appleical.text),
        null != e.facebook && null != e.facebook.text && (L = e.facebook.text),
        null != e.dropdown &&
          null != e.dropdown.order &&
          (h = e.dropdown.order));
    },
    keyboard: function (e, t) {
      var a = document.getElementById(t.id + "-drop");
      if (a && "block" == addeventatc.getstyle(a, "display")) {
        for (
          var n = a.getElementsByTagName("SPAN"), o = null, d = 0, c = 0, i = 0;
          i < n.length;
          i += 1
        )
          (d++,
            addeventatc.hasclass(n[i], "drop_markup") && ((o = n[i]), (c = d)));
        null === o
          ? (c = 1)
          : "down" == t.key
            ? d <= c
              ? (c = 1)
              : c++
            : 1 == c
              ? (c = d)
              : c--;
        for (var l, i = (d = 0); i < n.length; i += 1) {
          ++d == c
            ? ((n[i].className += " drop_markup"),
              (n[i].tabIndex = "0"),
              n[i].focus())
            : ((l = new RegExp("(\\s|^)drop_markup(\\s|$)")),
              (n[i].className = n[i].className.replace(l, " ")),
              (n[i].className = n[i].className.replace(/\s+$/, "")),
              (n[i].tabIndex = "-1"));
        }
      }
    },
    keyboardclick: function (e, t) {
      var a = document.getElementById(t.id + "-drop");
      if (a) {
        for (
          var n = a.getElementsByTagName("SPAN"), o = null, d = 0;
          d < n.length;
          d += 1
        )
          addeventatc.hasclass(n[d], "drop_markup") && (o = n[d]);
        if (null !== o) {
          o.click();
          for (d = 0; d < n.length; d += 1) {
            var c = new RegExp("(\\s|^)drop_markup(\\s|$)");
            ((n[d].className = n[d].className.replace(c, " ")),
              (n[d].className = n[d].className.replace(/\s+$/, "")));
          }
        }
      }
    },
    usewebcal: function () {
      var e = !1,
        t = !1,
        a = window.navigator.userAgent.toLowerCase();
      navigator.userAgent.match(/CriOS|FxiOS|OPiOS|mercury|gsa/i) && (t = !0);
      var n = /iphone|ipod|ipad/.test(a);
      (-1 < a.indexOf("fban") || (-1 < a.indexOf("fbav") && n)) && (t = !0);
      var o = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
        navigator.userAgent,
      );
      return (
        ((n && o) || (n && t)) &&
          (alert(
            'If the event fails to load please \n"Open the page in Safari".',
          ),
          (e = !0)),
        e
      );
    },
    agent: function () {
      var e = navigator.userAgent || navigator.vendor || window.opera;
      return /windows phone/i.test(e)
        ? "windows_phone"
        : /android/i.test(e)
          ? "android"
          : /iPad|iPhone|iPod/.test(e) && !window.MSStream
            ? "ios"
            : "unknown";
    },
    isloaded: function () {
      return !!e;
    },
    notloadedcnt: function () {
      for (
        var e = document.getElementsByClassName("addeventatc"), t = 0, a = 0;
        a < e.length;
        a += 1
      )
        "true" == e[a].getAttribute("data-loaded") && t++;
      e.length > t && addeventatc.refresh();
    },
  };
})();
!(function (e, t) {
  "use strict";
  ((e = e || "docReady"), (t = t || window));
  var a = [],
    n = !1,
    o = !1;
  function d() {
    if (!n) {
      n = !0;
      for (var e = 0; e < a.length; e++) a[e].fn.call(window, a[e].ctx);
      a = [];
    }
  }
  function c() {
    "complete" === document.readyState && d();
  }
  t[e] = function (e, t) {
    if ("function" != typeof e)
      throw new TypeError("callback for docReady(fn) must be a function");
    n
      ? setTimeout(function () {
          e(t);
        }, 1)
      : (a.push({ fn: e, ctx: t }),
        "complete" === document.readyState ||
        (!document.attachEvent && "interactive" === document.readyState)
          ? setTimeout(d, 1)
          : o ||
            (document.addEventListener
              ? (document.addEventListener("DOMContentLoaded", d, !1),
                window.addEventListener("load", d, !1))
              : (document.attachEvent("onreadystatechange", c),
                window.attachEvent("onload", d)),
            (o = !0)));
  };
})("addeventReady", window);
var ate_touch_capable =
  "ontouchstart" in window ||
  (window.DocumentTouch && document instanceof window.DocumentTouch) ||
  0 < navigator.maxTouchPoints ||
  0 < window.navigator.msMaxTouchPoints;
(window.addEventListener
  ? (document.addEventListener("click", addeventatc.documentclick, !1),
    ate_touch_capable &&
      document.addEventListener("touchend", addeventatc.documentclick, !1))
  : window.attachEvent
    ? (document.attachEvent("onclick", addeventatc.documentclick),
      ate_touch_capable &&
        document.attachEvent("ontouchend", addeventatc.documentclick))
    : (document.onclick = function () {
        addeventatc.documentclick(event);
      }),
  addeventReady(function () {
    addeventatc.initialize();
  }));
var flbckcnt = 0,
  flbckint = setInterval(function () {
    15 <= ++flbckcnt || addeventatc.isloaded()
      ? clearInterval(flbckint)
      : addeventatc.initialize();
  }, 300),
  nlbckcnt = 0,
  nlbckint = setInterval(function () {
    15 <= ++nlbckcnt ? clearInterval(nlbckint) : addeventatc.notloadedcnt();
  }, 300);
